import styled from 'styled-components'

import { SIZES, COLORS2 } from '~/common/globalStyles'

export interface InputComponentProps {
  disabled?: boolean
  placeholderColor?: string
  ref:
    | React.RefObject<HTMLInputElement | null>
    | ((node: HTMLInputElement) => void)
}

const StyledInput = styled.input<InputComponentProps>`
  background-color: transparent;
  font-size: ${SIZES.medium};
  padding: ${SIZES.xs} 0;
  flex: 1;
  min-width: 0;
  border: 0;
  /* this width is to fix a nested grid issue in certain
  scenarios */
  width: 100%;
  /* Fix for FF red border on required fields */
  box-shadow: none;

  &:focus {
    border: 0;
    outline: none;
  }
  ${({ placeholderColor }) =>
    placeholderColor &&
    `
  ::placeholder {
    color: ${COLORS2.gray[100]};
    opacity: 1;
  }
  `}

  &:disabled {
    background-color: transparent;
    &::placeholder {
      color: #96a3b6;
    }
  }
`

export default StyledInput
